export default "__VITE_ASSET__Bs6FB1HX__"